import * as React from 'react';
import { FlatPlanLayout } from './components/FlatPlanLayout';
import { FlatPlanHeader } from './components/FlatPlanHeader';
import { FlatImage } from './components/FlatImage';
import { TrackingContext } from '../../../../tracking/TrackingContext';
import { jsx as _jsx } from "react/jsx-runtime";
export var FlatPlan = function FlatPlan(_ref) {
  var flat = _ref.flat,
    onClose = _ref.onClose,
    rightPanel = _ref.rightPanel;
  var _React$useContext = React.useContext(TrackingContext),
    onOfferLinkClick = _React$useContext.onOfferLinkClick;
  var onOfferClick = function onOfferClick() {
    onOfferLinkClick(flat.id);
  };
  return /*#__PURE__*/_jsx(FlatPlanLayout, {
    header: /*#__PURE__*/_jsx(FlatPlanHeader, {
      onClose: onClose,
      onOfferClick: onOfferClick,
      title: flat.description,
      offerUrl: flat.offer.url
    }),
    plan: /*#__PURE__*/_jsx(FlatImage, {
      src: flat.flatPlanUrl
    }),
    rightPanel: rightPanel
  });
};